// LICENSE DETAILS APPENDED AT BOTTOM OF PAGE

import * as UTIL from './scripts/utilities.js';
import { LOAD_HTML } from "./scripts/loadHTML";
import { UPLOAD } from "./scripts/uploadImages";
import { MAKE_IMGS } from "./scripts/makeCollageImages";
import { FLOAT } from "./scripts/float";
import { DRAG } from "./scripts/drag";
import { EDIT } from "./scripts/edit";

let isFloating;
const togFloating = function(){
  if(isFloating){
    FLOAT.stopFloating();
    isFloating = false;
  } else {
    FLOAT.startFloating();
    isFloating = true;
  }
}

const addListenersToImgs = function(){
  return new Promise(function(resolve, reject){
    const collageImgsCollection = Array.from(collageWrapper.children);

    collageImgsCollection.forEach(function(img){
      img.addEventListener('click', function(e){
        if (!e.shiftKey && !e.ctrlKey) {
          img.classList.toggle("canMove");
        } 
        
        if (e.shiftKey) {
          EDIT.initEdit(img);
        }
      });
    });
    
    resolve();
  });
}
// If uploads done => make & append collage images
//  .then add event listeners to each new image
//  .then start floating action for all
const checkUploadsDone = function(){
  let allDone = false;

  if (UPLOAD.isCollagePrepDone()){ allDone = true; }
  
  if (allDone){
    MAKE_IMGS.collageImages() 
      .then(addListenersToImgs() )
      .then(isFloating = true, togFloating() )
    ; 
  } 
  else { setTimeout(function(){ checkUploadsDone(); }, 1000); }
}

const loadEventListeners = function () {

  // Handle non-editing hotkeys
  document.addEventListener("keyup",function (e) {

    // Toggle Floating - < spacebar >
    if (e.keyCode == 32 || e.which == 32) { togFloating(); }

    // Show help modal - < h >
    if (e.keyCode == 72 || e.which == 72) { document.getElementById("helpBtn").click(); }
  });

  // Handle upload
  upload.addEventListener("change",function(){
    UPLOAD.userImages() 
      .then(checkUploadsDone()); 
  });

  // Create collage
  createBtn.addEventListener("click",function(){ 
    UTIL.setCollageCss() 
      .then(fullscreen.requestFullscreen())
    ; 
  });

  // Handle fullscreen
  document.addEventListener("fullscreenchange",function(){
    UTIL.handleFullscreen()
      .then(togFloating)
    ;
  })

  // Handle drag-n-drop
  collageWrapper.addEventListener("mousedown", DRAG.dragStart, false);
  collageWrapper.addEventListener("mousemove", DRAG.drag, false);
  collageWrapper.addEventListener("mouseup", DRAG.dragEnd, false);
};

LOAD_HTML() .then(loadEventListeners());

// LICENSE
/* 
  Parcel bundling based on 'Vanilla JS Parcel Boilerplate' from Brad Traversy's
  YouTube tutorial 'Easy Frontend JS Workflow With No Framework' - which he
  provides with the MIT License below: 
  _________________________________________________________________________________

  MIT License

  Copyright (c) 2020 Brad Traversy

  Permission is hereby granted, free of charge, to any person obtaining a copy
  of this software and associated documentation files (the "Software"), to deal
  in the Software without restriction, including without limitation the rights
  to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
  copies of the Software, and to permit persons to whom the Software is
  furnished to do so, subject to the following conditions:

  The above copyright notice and this permission notice shall be included in all
  copies or substantial portions of the Software.

  THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
  IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
  FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
  AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
  LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
  OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
  SOFTWARE.
  _________________________________________________________________________________

*/
